import DriverActualsBookingPanel from '@/components/driver_actuals_booking_panel.vue'
import {
  buildBookingDetailsFromSegments,
  buildFullBookingDetails,
  panelPositionFromEvent,
  panelPositionUnderSegments,
} from '@/helpers/driver_actuals_booking_details'

export default {
  components: {
    DriverActualsBookingPanel,
  },

  data() {
    return {
      booking_panel_visible: false,
      booking_panel_details: [],
      booking_panel_style: {},
      booking_panel_hide_timer: null,
      timeline_hover_cell_key: null,
      // click-on-a-bar modal (complete booking details)
      booking_modal_visible: false,
      booking_modal_details: [],
      booking_modal_loading: false,
    }
  },

  beforeDestroy() {
    this.clearBookingPanelHideTimer()
    if (this._filterDebounceTimer) {
      clearTimeout(this._filterDebounceTimer)
      this._filterDebounceTimer = null
    }
  },

  methods: {
    bookingDetailVariant() {
      return 'cm'
    },
    bookingDetailResourceType() {
      return 'vehicle'
    },
    bookingDetailPlannedOnly() {
      return false
    },
    // pages that want a per-booking "open in actuals" link in the hover panel
    // return the actuals route path here (e.g. '/actuals_tbn'); null = no link
    bookingDetailActualsPath() {
      return null
    },
    clearBookingPanelHideTimer() {
      if (this.booking_panel_hide_timer) {
        clearTimeout(this.booking_panel_hide_timer)
        this.booking_panel_hide_timer = null
      }
    },
    scheduleHideBookingPanel() {
      this.clearBookingPanelHideTimer()
      this.booking_panel_hide_timer = setTimeout(() => {
        this.booking_panel_visible = false
        this.booking_panel_details = []
        this.timeline_hover_cell_key = null
      }, 250)
    },
    scheduleFilterResults() {
      if (this._filterDebounceTimer)
        clearTimeout(this._filterDebounceTimer)
      this._filterDebounceTimer = setTimeout(() => {
        this._filterDebounceTimer = null
        this.filter_results()
      }, 250)
    },
    onTimelineCellHover({ event, segments, cellKey }) {
      this.clearBookingPanelHideTimer()
      if (!segments || !segments.length) {
        this.timeline_hover_cell_key = null
        this.scheduleHideBookingPanel()
        return
      }
      if (cellKey === this.timeline_hover_cell_key)
        return
      this.timeline_hover_cell_key = cellKey
      const datetimeFormat = (this.summary && this.summary.datetime_format) || 'MM/DD/YYYY hh:mm A'
      // no actuals link on the hover (not reliably clickable); the click
      // modal carries it instead
      this.booking_panel_details = buildBookingDetailsFromSegments(
        segments,
        this.bookingDetailVariant(),
        datetimeFormat,
        this.bookingDetailResourceType(),
        this.bookingDetailPlannedOnly()
      )
      // anchor centered under the hovered bar so the panel holds still while
      // the pointer sweeps it; cursor position is only the fallback
      const cellEl = event && event.target && event.target.closest
        ? event.target.closest('td.driver-actuals-util-slice')
        : null
      this.booking_panel_style =
        panelPositionUnderSegments(cellEl, segments) || panelPositionFromEvent(event)
      this.booking_panel_visible = true
    },
    onTimelineCellLeave() {
      this.timeline_hover_cell_key = null
      this.scheduleHideBookingPanel()
    },
    // pages whose timeline rows already hold the actuals web records return
    // them directly (the default); VSM Upcoming overrides this with a fetch
    // by booking ref so the modal can show the complete record
    fetchBookingModalRecords(segments) {
      return segments.map(seg => seg && seg.booking).filter(Boolean)
    },
    async onTimelineCellClick({ segments }) {
      if (!segments || !segments.length)
        return
      const datetimeFormat = (this.summary && this.summary.datetime_format) || 'MM/DD/YYYY hh:mm A'
      // summary content immediately (the click shouldn't wait on a fetch)
      this.booking_modal_details = buildBookingDetailsFromSegments(
        segments,
        this.bookingDetailVariant(),
        datetimeFormat,
        this.bookingDetailResourceType(),
        this.bookingDetailPlannedOnly(),
        this.bookingDetailActualsPath()
      )
      // the modal supersedes the hover panel; don't stack the two
      this.clearBookingPanelHideTimer()
      this.booking_panel_visible = false
      this.timeline_hover_cell_key = null
      this.booking_modal_visible = true
      // then upgrade to the complete actuals-page field set
      this.booking_modal_loading = true
      try {
        const records = await this.fetchBookingModalRecords(segments)
        if (records && records.length && this.booking_modal_visible) {
          const details = buildFullBookingDetails(
            records,
            this.bookingDetailVariant(),
            datetimeFormat,
            this.bookingDetailResourceType(),
            this.bookingDetailActualsPath()
          )
          // fetched records never cover maintenance events; carry those over
          for (const detail of this.booking_modal_details) {
            if (detail.is_service_event)
              details.push(detail)
          }
          if (details.length)
            this.booking_modal_details = details
        }
      } catch (e) {
        // keep the summary details; the modal is still useful without the fetch
      }
      this.booking_modal_loading = false
    },
    onBookingPanelEnter() {
      this.clearBookingPanelHideTimer()
    },
    onBookingPanelLeave() {
      this.scheduleHideBookingPanel()
    },
  },
}
